<template>
  <b-modal
    :title="title"
    :size="size"
    no-close-on-backdrop
    @hidden="$emit('hidden')"
    ref="modal"
  >
    <div slot="default">
      <div>
        <p v-html="bodyText"></p>
      </div>
    </div>
    <div slot="modal-footer">
      <div class="button-items">
        <button
          type="button"
          class="btn btn-outline-primary waves-effect waves-light"
          @click="$emit('confirm')"
        >
          OK
        </button>
        <!-- <button
          type="button"
          class="btn btn-outline-light waves-effect"
          @click="onClose"
        >
          Close
        </button> -->
      </div>
    </div>
  </b-modal>
</template>

<script>
import { eventBus } from '@/main.js'
export default {
  name: 'ConfirmModalComponent',
  props: {
    title: { type: String, default: 'Confirm' },
    size: { type: String, default: 'md' },
    bodyText: { type: String, default: null },
    show: { type: Boolean, default: false },
  },
  data() {
    return {
      pattern: 'confirm',
      // remark: '',
      // bodyText: '',
    }
  },
  watch: {
    show: function(value) {
      console.log('show', value)
      if (value) {
        this.$refs.modal.show()
      } else this.$refs.modal.hide()
    },
  },
  methods: {
    onConfirm() {
      this.$refs.modal.hide()
      this.$emit('confirm')
    },
  },
}
</script>
<style>
.modal-content.no-content > .modal-body {
  display: none;
}
.modal-content > .modal-footer button {
  font-size: 12px;
}
/* danger */
.modal-content.danger > .modal-header {
  background-color: tomato;
  color: white;
}
.modal-content.danger > .modal-footer .confirm {
  background-color: tomato;
  color: white;
}
/* approve */
.modal-content.approve > .modal-header {
  background-color: olivedrab;
  color: white;
}
.modal-content.approve > .modal-footer .confirm {
  background-color: olivedrab;
  color: white;
}
/* confirm */
.modal-content.confirm > .modal-header {
  background-color: #556ee6;
  color: white;
}
.modal-content.confirm > .modal-footer .confirm {
  background-color: #556ee6;
  color: white;
}
/* info */
.modal-content.info > .modal-header {
  background-color: #34c38f;
  color: white;
}
.modal-content.info > .modal-footer .confirm {
  background-color: #34c38f;
  color: white;
}
</style>
